import React, { createContext, useState } from "react";

export const SelectedCategoryContext = createContext(); 

export const SelectedCategoryProvider = ({ children }) => {
    const [selectedCategory, setSelectedCategory] = useState('None');

  return (
    <SelectedCategoryContext.Provider value={{ selectedCategory, setSelectedCategory }}>
      {children} 
    </SelectedCategoryContext.Provider>
  );
};
